import React from 'react';
import { StatusLabelModel } from '../../../models/grid.model';

interface IProps extends StatusLabelModel {
}

export const StatusRenderer = (props: IProps) => {
    return (
        <div className={`status-variant-${props.Variant} ${props.ClassName}`} key={props.Id}>
            {props.Label}
        </div>
    );
};
